import React from "react";
import Axios from 'axios'
import DetalhamentoPedido from "../_Components/DetalhamentoPedido"
import SubMasterTemplate from "./SubMasterTemplate";
import moment from 'moment';

export class SubMasterRecebidos extends React.Component {
  constructor(props) {
    window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
    super(props);
    this.state = {
      pedidos: [],
      user: JSON.parse(localStorage.getItem("user")),
    };
    this.listarPedidos();

  }


  imprimirPedido(e) {
    localStorage.setItem('printItem', e.target.accessKey)
    window.location.href = '/imprimir?pedido=' + e.target.accessKey;

  }

  formatDate(data) {
    return moment(data).add(0, 'days').format('DD-MM-YYYY')
  }

  getUser = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("usuarios/user", {
        id: this.state.user._id
      });

      window.localStorage.setItem("user", JSON.stringify(response.data[0]));
      this.setState({ user: response.data[0] });
    } catch (err) {
      console.log(err);
    }
  };

  listarPedidos = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("pedidos/listar-pedidos-submaster", {
        id: this.state.user._id
      });
      this.setState({ pedidos: response.data.reverse() });
      console.log(response.data)
    } catch (err) {
      console.log(err);
    }
  };



  render() {
    return (
      <SubMasterTemplate label="Lista de Pedidos Recebidos">
        <div class="content">
          <div class="container-fluid">

            <div class="row">
              <div class="col-md-12">
                <div class="card strpied-tabled-with-hover">
                  <div class="card-header ">
                    <p class="card-category">Informações de recebidos.</p>
                    <span>Total de <span className="text-danger">{this.state.pedidos.length} </span>recebidos</span>
                  </div>
                  <div class="card-body table-full-width table-responsive">
                    <table class="table table-hover table-striped">
                      <thead>
                        <tr>
                          <th>Data de recebimento</th>
                          <th>Cliente</th>
                          <th>Código do pedido</th>
                          <th>Imprimir</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.pedidos?.map(pedido => {
                          return (
                            <tr class="align-items-center">
                              <td>{this.formatDate(pedido.data)}</td>
                              <td>{pedido.clienteId.nome}</td>
                              <td>{pedido.codigo}</td>
                              <td>
                                <button onClick={this.imprimirPedido.bind(this)} class={"btn-fill btn btn-success"} accessKey={pedido._id} >IMPRIMIR</button>
                              </td>
                            </tr>)
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SubMasterTemplate>
    );
  }
}

export default SubMasterRecebidos;
